import { render, staticRenderFns } from "./IconCollectionSolid.vue?vue&type=template&id=7e81d5b8"
import script from "./IconCollectionSolid.vue?vue&type=script&lang=js"
export * from "./IconCollectionSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports